
import {Options, Vue} from 'vue-class-component';
import {User} from '@/types/auth';
import ModuleAuth from '@/store/auth';

@Options({
    name: 'MainContent',
})
export default class MainContent extends Vue {
    async mounted() {
        await ModuleAuth.attemptLogin();
    }

    public logout() {
        ModuleAuth.logout();
    }

    get userLoggedIn(): User | undefined {
        return ModuleAuth.userLoggedIn;
    }
}
